// Rules of the Pipeline quick panel (Pipeline proposal D-04, G3 arbitrage n°1). Pure: tested in quickPanel.test.js.

export const PHONE_MAX = 767;
// "drawer" = modal drawer on the right with the board dimmed behind it (user's decision B, 25/10/2026); "sheet" = bottom sheet on a phone.
export const panelMode = (viewport) => (viewport <= PHONE_MAX ? "sheet" : "drawer");

// A first opening pushes a history entry (Back closes the panel); switching to another pharmacy replaces it.
export const ficheNavigation = (currentId) => (currentId ? "replace" : "push");

// Exchanges that count as a real contact with the pharmacy (a simple note does not).
export const CONTACT_TYPES = ["call", "whatsapp", "email", "meeting", "demo"];
export const RECENT_EXCHANGES = 5;

// From the prospect's feed (interactions + system events): the last real contact and the five latest exchanges.
export function summariseExchanges(feed) {
  const interactions = (feed || []).filter((e) => e.kind === "interaction").sort((a, b) => String(b.occurred_at).localeCompare(String(a.occurred_at)));
  return {
    lastContact: interactions.find((i) => CONTACT_TYPES.includes(i.type)) || null,
    recent: interactions.slice(0, RECENT_EXCHANGES),
  };
}

// Open tasks of a prospect, earliest due date first, undated last (same order as the card's « next action »).
export function openTasks(tasks) {
  const open = (tasks || []).filter((t) => !t.done && t.status !== "annulee" && t.status !== "termine");
  const dated = open.filter((t) => t.due_date).sort((a, b) => a.due_date.localeCompare(b.due_date));
  return [...dated, ...open.filter((t) => !t.due_date)];
}
